// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".question[data-v-b632402e]{cursor:pointer;margin-bottom:.3em}.question-type[data-v-b632402e]{font-size:.8em;color:#aaa;line-height:1.2em;margin-top:.2em}img[data-v-b632402e]{max-width:-moz-max-content;max-width:max-content;width:100%;border-radius:4px}", ""]);
// Exports
module.exports = exports;
